package top.wcpe.allincore.ui.runtime.element

/**
 * 滚动方向：决定 [ScrollableContainer] 哪些滚动轴有效，以及滚轮/拖拽事件如何映射到 X/Y 偏移。
 *
 * - [VERTICAL]：仅垂直滚动，水平偏移恒为 0（默认，向后兼容旧 ScrollView/VirtualList）。
 * - [HORIZONTAL]：仅水平滚动，垂直偏移恒为 0。
 * - [BOTH]：水平与垂直均可滚动。
 */
enum class ScrollDirection {
    /** 仅垂直滚动。 */
    VERTICAL,

    /** 仅水平滚动。 */
    HORIZONTAL,

    /** 双向滚动。 */
    BOTH,
}
